import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M28.956 24.319 24.808 4.594a2 2 0 0 0-2.375-1.55L16.58 4.303a2.01 2.01 0 0 0-1.537 2.375l4.148 19.725a2 2 0 0 0 2.375 1.553l5.852-1.258a2.01 2.01 0 0 0 1.537-2.378M17 6.269v-.012l5.85-1.25.416 1.984-5.85 1.259zm.828 3.933 5.852-1.256.418 1.988-5.848 1.257zm.83 3.947 5.852-1.258 1.662 7.905-5.852 1.258zM27 24.742l-5.85 1.25-.416-1.983 5.85-1.26.416 1.982zM13 4H7a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2M7 6h6v2H7zm0 4h6v12H7zm6 16H7v-2h6z"
    />
  </svg>
);
const SvgIconLearningAcademy1 = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconLearningAcademy1);
export default Memo;
